module.exports = __webpack_public_path__ + "static/media/course_responses_empty_state.e307428d.svg";